import {
  SET_MEMBERSHIP,
  LOADING_END,
  LOADING_START,
  //   SET_ERROR,
} from "./types";
import MembershipServices from "../../services/membership.services";
import { openNotification } from "../Notification/notifications.action";

export const getSubscribedPlan = () => (dispatch) => {
  dispatch({ type: LOADING_START });
  return MembershipServices.getSubscribedPlan()
    .then(({ data: { data } }) => {
      dispatch({ type: LOADING_END });
      dispatch({ type: SET_MEMBERSHIP, payload: data });
    })
    .catch((err) => {
      const error = err?.response?.data?.data || "Something Happened";
      console.log("err", error);

      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: LOADING_END });
    });
};

export const createCheckoutSession = (wavecardQuantity) => (dispatch) => {
  dispatch({ type: LOADING_START });
  return MembershipServices.createCheckoutSession(wavecardQuantity)
    .then(({ data: { data } }) => {
      dispatch({ type: LOADING_END });
      window.open(data, "_self").focus();
    })
    .catch((err) => {
      const error = err?.response?.data.data || "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: LOADING_END });
    });
};
export const buySubscriptionPlan = (wavecardQuantity) => (dispatch) => {
  dispatch({ type: LOADING_START });
  return MembershipServices.buySubscriptionPlan(wavecardQuantity)
    .then(({ data: { data } }) => {
      dispatch({ type: LOADING_END });
      dispatch({ type: SET_MEMBERSHIP, payload: data });
      openNotification({
        message: "Success",
        description: "Subscription purchased successfully",
        icon: "success",
      });
    })
    .catch((err) => {
      const error = err?.response?.data?.data || "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: LOADING_END });
    });
};
export const changeSubscriptionPlan = (wavecardQuantity) => (dispatch) => {
  dispatch({ type: LOADING_START });
  return MembershipServices.changeSubscriptionPlan(wavecardQuantity)
    .then(({ data: { data } }) => {
      dispatch({ type: LOADING_END });
      dispatch({ type: LOADING_END });
      dispatch({ type: SET_MEMBERSHIP, payload: data });
      openNotification({
        message: "Success",
        description: "Subscription upgraded successfully",
        icon: "success",
      });
    })
    .catch((err) => {
      const error = err?.response?.data?.data || "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: LOADING_END });
    });
};

export const cancelSubscribedPlan = () => (dispatch) => {
  dispatch({ type: LOADING_START });
  return MembershipServices.cancelSubscribedPlan()
    .then(({ data: { data } }) => {
      dispatch({ type: LOADING_END });
      dispatch({ type: SET_MEMBERSHIP, payload: {} });
      openNotification({
        message: "Success",
        description: "Subscription cancelled successfully",
        icon: "success",
      });
    })
    .catch((err) => {
      const error =
        err?.response?.data ||
        err?.response?.data?.data ||
        "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: LOADING_END });
    });
};

export const getStripId = () => (dispatch) => {
  return MembershipServices.getStripeId()
    .then(({ data: { data } }) => {
      dispatch({ type: "SET_STRIPE_ID", payload: data });
    })
    .catch(() => {
      dispatch({ type: LOADING_END });
    });
};

//////////////////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
export const buySubscriptionPlanBeta = (plan) => (dispatch) => {
  dispatch({ type: LOADING_START });
  return MembershipServices.buySubscriptionPlan(plan)
    .then(({ data: { data } }) => {
      dispatch({ type: LOADING_END });
      dispatch({ type: SET_MEMBERSHIP, payload: data });
      openNotification({
        message: "Success",
        description: "Subscription purchased successfully",
        icon: "success",
      });
    })
    .catch((err) => {
      const error = err?.response?.data?.data || "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: LOADING_END });
    });
};
export const changeSubscriptionPlanBeta = (plan) => (dispatch) => {
  dispatch({ type: LOADING_START });
  return MembershipServices.changeSubscriptionPlan(plan)
    .then(({ data: { data } }) => {
      dispatch({ type: LOADING_END });
      dispatch({ type: SET_MEMBERSHIP, payload: data });
      openNotification({
        message: "Success",
        description: "Subscription upgraded successfully",
        icon: "success",
      });
    })
    .catch((err) => {
      const error = err?.response?.data?.data || "Something Happened";
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: LOADING_END });
    });
};

export const cancelSubscribedPlanBeta = () => (dispatch) => {
  dispatch({ type: LOADING_START });
  return MembershipServices.cancelSubscribedPlan()
    .then(({ data: { data } }) => {
      dispatch({ type: LOADING_END });
      dispatch({ type: SET_MEMBERSHIP, payload: {} });
      openNotification({
        message: "Success",
        description: "Subscription cancelled successfully",
        icon: "success",
      });
    })
    .catch((err) => {
      const error = err?.response?.data?.data || "Something Happened";
      console.log({ error });
      openNotification({
        message: "Error",
        description: error,
        icon: "error",
      });
      dispatch({ type: LOADING_END });
    });
};
